export default "__VITE_ASSET__Cf6qyipV__"